import React, { useEffect, useState, useMemo } from 'react';
import $ from 'jquery';
import { NavLink, Link } from 'react-router-dom';
import { Popover, OverlayTrigger, Modal, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';


function Alarm(props) {

    return (
        <div className={(props.lastone ? "" : "border-bottom") + " p-1 row alarmrow "}>
            <div className={"p-1 rounded border"} style={{ fontSize: '12px', 'display': 'inline-block' }}>
                {props.alarm.Time}
            </div>
            {props.alarm.Name}
        </div>);
    
}

function AlarmPill (props) {
    const { t } = useTranslation();
    const [siteGUID, setSiteGUID] = useState(props.SiteGUID);
    useEffect(() => {
      setSiteGUID(props.SiteGUID);
    }, [props.SiteGUID]);
  
    // Store alarms locally. If you do not need to modify alarms internally,
    // you could use the prop directly. Here we mimic the class component.
    const [localAlarms, setLocalAlarms] = useState(props.alarms || []);
    useEffect(() => {
      if (props.alarms !== undefined) {
        setLocalAlarms(props.alarms);
      }
    }, [props.alarms]);
  
    // Calculate the number of unread alarms.
    const numberUnread = localAlarms.length;
  
    // Compute the alarm render objects whenever localAlarms change.
    const alarmRenderObjects = useMemo(() => {
      return localAlarms.map((alarmItem, i) => (
        <Alarm
          key={`${i}alarm`}
          lastone={i === localAlarms.length - 1}
          alarm={alarmItem}
        />
      ));
    }, [localAlarms]);
  
    return (
      <div>
        <OverlayTrigger
          trigger="click"
          placement="auto"
          rootClose={true}
          overlay={
            <Popover>
              <Popover.Header as="h3">
                <div className="row">
                  <div className="col pe-0">
                    {numberUnread} {numberUnread === 1 ? t("components.alarmheader.alarm-singular") : t("components.alarmheader.alarm-plural")}
                  </div>
                  <div className="col ps-0 text-end">
                    <NavLink
                      tag={Link}
                      className="nav-icon-container"
                      to={`/Alarms/${siteGUID}`}
                    >
                      <div>{t("components.alarmheader.alarmsnsetup")}</div>
                    </NavLink>
                  </div>
                </div>
              </Popover.Header>
              <Popover.Body style={{ overflowY: 'scroll', height: '400px' }}>
                <div className="col">{alarmRenderObjects}</div>
              </Popover.Body>
            </Popover>
          }
        >
          <div
            className="border rounded-pill p-2 d-flex justify-content-center notificationpill me-3"
            id="alarmspopover"
          >
            <i
              className={
                'fa-2x fad fa-swap-opacity fa-bell' +
                (numberUnread > 0 ? ' text-warning' : '') +
                ' ms-2 mt-1'
              }
              aria-hidden="true"
            ></i>
            <div className="h4 mt-2 ms-2 me-1" id="AlarmNumber">
              {numberUnread}
            </div>
          </div>
        </OverlayTrigger>
      </div>
    );
  };
  
  export default AlarmPill;